import React from 'react';
import {Link} from 'react-router-dom'

import './izvestajisection.styles.css'
import IzvestajItemMein from '../izvestajitemmain/izvestajitemmein.component'
   
            

const IzvestajiSection = props => {    
    return(
    <section className="section-stories">
        <div className="bg-video">
            <video className="bg-video__content" autoPlay muted loop>
                <source src="img/video.mp4" type="video/mp4" />
                <source src="img/video.webm" type="video/webm" />
                Your browser is not supported!
            </video>
        </div>

        <div className="u-center-text u-margin-bottom-big">
            <h2 className="heading-secondary">
               Izveštaji sa Akcija
            </h2>
        </div>  
       <div> 
       {props.items && props.items.map(izvestaj => ( <IzvestajItemMein key={izvestaj.id} id={izvestaj.id} naslov={ izvestaj.naslov } opis={izvestaj.opis} datum={izvestaj.datum} 
       image={`${process.env.REACT_APP_ASSET_URL}/${izvestaj.image}`} /> ))}
    </div>


        <div className="u-center-text u-margin-top-huge">
            <Link to={'/izvestaji'} className="btn-text">Pogledaj sve Izveštaje &rarr;</Link>
        </div>
    </section>
   
);
        }

export default IzvestajiSection;